<template>
    <div class="mi-box">
        <div class="top-box-content">
            <div style="display: flex;">
                <div>
                    <div class="img-box">
                        <el-image class="img-detail"
                            :src="detail.softwareCover ? $severUrl(detail.softwareCover) : $filterResDefault('虚拟仿真')"
                            fit="cover"></el-image>
                    </div>
                    <div class="detail-show-title">
                        <el-tooltip class="item" effect="dark" :content="detail.softwareName" placement="top-start">
                            <div class="page-title overflow">{{ detail.softwareName }}</div>
                        </el-tooltip>
                        <div class="rate-box">
                            <el-rate v-model="detail.evaluateScore" disabled show-score text-color="#999999"
                                score-template="{value}">
                            </el-rate>
                            <div>({{ detail.evaluateCount || 0 }}人评价)</div>
                            <i class="iconfont icon-bianji" v-if="!detail.evaluate" @click="openDialog"></i>
                            <i class="iconfont icon-chakan" style="font-size: 2rem;margin-left: 1rem;"></i>
                            <div class="ev-num">{{ detail.viewCount || 0 }}</div>
                        </div>
                    </div>
                </div>
                <div style="margin-left: 6rem;">
                    <p class="title">软件详情</p>
                    <div>
                        <div class="js-item">
                            <p>负责老师：</p>
                            <div>{{ detail.teacherName || '暂无' }}</div>
                        </div>
                        <div class="js-item">
                            <p>所属院校：</p>
                            <div>{{ detail.institutions || '暂无' }}</div>
                        </div>
                        <div class="js-item">
                            <p>上线时间：</p>
                            <div>{{ detail.createTime || '暂无' }}</div>
                        </div>
                        <div class="js-item">
                            <p>实训步骤：</p>
                            <div>{{ detail.lastModulesCount || 0 }}</div>
                        </div>
                    </div>
                    <div class="first-box">
                        <div class="btn-box">
                            <div class="common-btn" @click="startTrain">开始实训</div>
                            <div>
                                <img :src="detail.likes ? good : noGood" class="good" style="cursor: pointer;"
                                    @click="addOptRecord(OPERATIONTYPE[0])" alt="">
                                <div>{{ numberDivide(detail.up) }}</div>
                            </div>
                            <div>
                                <img :src="detail.collect ? collect : noCollect" class="sc" style="cursor: pointer;"
                                    @click="addOptRecord(OPERATIONTYPE[1])" alt="">
                                <div>{{ numberDivide(detail.sc) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-mi-box">
            <div class="left-box">
                <div style="display: flex;">
                    <p class="info-title" :class="{ 'active-title': currentShowTitle == 'xfjs' }"
                        @click="changeTitle('xfjs')">虚仿介绍</p>
                    <p class="info-title" :class="{ 'active-title': currentShowTitle == 'sxbd' }"
                        @click="changeTitle('sxbd')" style="margin-left: 2rem;">实训必读</p>
                    <p class="info-title" :class="{ 'active-title': currentShowTitle == 'yhpl' }"
                        @click="changeTitle('yhpl')" style="margin-left: 2rem;">{{ `用户评论（${evaluateNumber}）` }}</p>
                </div>
                <div v-show="currentShowTitle == 'xfjs'">
                    <div class="info-content" v-if="detail.explainInfo">
                        <div v-for="(item, index) in trimSpecialChars(detail.explainInfo).split('#')" :key="index">{{
                            item }}</div>
                    </div>
                    <no-data v-else></no-data>
                    <el-tabs v-model="activeName" style="margin-top: 2rem;">
                        <el-tab-pane label="实训目标" name="target">
                            <div v-if="detail.drillTarget" class="content-ev-box">
                                <p v-for="(item, index) in trimSpecialChars(detail.drillTarget).split('#')" :key="index"
                                    class="detail-p">{{ item }}</p>
                            </div>
                            <no-data v-else></no-data>
                        </el-tab-pane>
                        <el-tab-pane label="实训原理" name="principle">
                            <div v-if="detail.drillTheory" class="content-ev-box">
                                <p v-for="(item, index) in trimSpecialChars(detail.drillTheory).split('#')" :key="index"
                                    class="detail-p">{{ item }}</p>
                            </div>
                            <no-data v-else></no-data>
                        </el-tab-pane>
                        <el-tab-pane label="实训方法与过程" name="process">
                            <div v-if="detail.drillMethodCourse" class="content-ev-box">
                                <p v-for="(item, index) in trimSpecialChars(detail.drillMethodCourse).split('#')"
                                    :key="index" class="detail-p">{{ item }}</p>
                            </div>
                            <no-data v-else></no-data>
                        </el-tab-pane>
                        <el-tab-pane label="实训步骤" name="step">
                            <div v-if="detail.drillStep" class="content-ev-box">
                                <p v-for="(item, index) in trimSpecialChars(detail.drillStep).split('#')" :key="index"
                                    class="detail-p">{{ item }}</p>
                            </div>
                            <no-data v-else></no-data>
                        </el-tab-pane>
                        <el-tab-pane label="实训结论" name="conclusion">
                            <div v-if="detail.drillConclusion" class="content-ev-box">
                                <p v-for="(item, index) in trimSpecialChars(detail.drillConclusion).split('#')"
                                    :key="index" class="detail-p">{{ item }}</p>
                            </div>
                            <no-data v-else></no-data>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div v-show="currentShowTitle == 'sxbd'">
                    <el-tabs v-model="activeRead" style="margin-top: 2rem;">
                        <el-tab-pane label="硬件要求" name="hardware">
                            <div v-if="detail.hardwareAsk" class="content-ev-box">
                                <p v-for="(item, index) in trimSpecialChars(detail.hardwareAsk).split('#')" :key="index"
                                    class="detail-p">{{ item }}</p>
                            </div>
                            <no-data v-else></no-data>
                        </el-tab-pane>
                        <el-tab-pane label="操作系统" name="system">
                            <div v-if="detail.os" class="content-ev-box">
                                <p v-for="(item, index) in trimSpecialChars(detail.os).split('#')" :key="index"
                                    class="detail-p">{{ item }}</p>
                            </div>
                            <no-data v-else></no-data>
                        </el-tab-pane>
                        <el-tab-pane label="网络要求" name="network">
                            <div v-if="detail.networkAsk" class="content-ev-box">
                                <p v-for="(item, index) in trimSpecialChars(detail.networkAsk).split('#')" :key="index"
                                    class="detail-p">{{ item }}</p>
                            </div>
                            <no-data v-else></no-data>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div v-show="currentShowTitle == 'yhpl'">
                    <evaluate v-if="this.softwareId" ref="ev" :businessId="this.softwareId" @get_total="getTotal" businessType="software"></evaluate>
                </div>
            </div>
            <div class="right-box">
                <div class="second-box">
                    <p class="title">数据统计</p>
                    <div>
                        <div class="js-item">
                            <p>浏览量：</p>
                            <div>{{ detail.viewCount ? numberDivide(detail.viewCount) : 0 }}</div>
                        </div>
                        <div class="js-item">
                            <p>学习人数：</p>
                            <div>{{ statisticsData.studyCount ? numberDivide(statisticsData.studyCount) : 0 }}</div>
                        </div>
                        <div class="js-item">
                            <p>学习人次：</p>
                            <div>{{ statisticsData.studyNumberCount ? numberDivide(statisticsData.studyNumberCount) : 0 }}
                            </div>
                        </div>
                        <!-- <div class="js-item">
                            <p>平均用时：</p>
                            <div>{{ (statisticsData.avgTime || 0) }}</div>
                        </div>
                        <div class="js-item">
                            <p>完成率：</p>
                            <div>{{ statisticsData.finish ? statisticsData.finish + "%" : 0 }}</div>
                        </div> -->
                    </div>
                    <div id="chart-box"></div>
                </div>
                <div class="three-box">
                    <p class="title">推荐虚仿软件</p>
                    <div v-for="(item, index) in reCourse" @click="toDetail(item)" class="re-item" :key="index">
                        <img class="img-cover-all" :src="item.coverImageUrl ? $severUrl(item.coverImageUrl) : $virtual" style="object-fit: cover;"
                            alt="">
                        <div class="item">
                            <div>{{ item.name }}</div>
                            <div>{{ item.schoolName || '暂无' }}</div>
                            <div style="display: flex;">
                                <span style="margin-right: 0.5rem;">{{ item.evaluateScore }}</span>
                                <span><el-rate disabled v-model="item.evaluateScore"></el-rate></span>
                            </div>
                        </div>
                    </div>
                    <no-data style="margin-top: 3rem;" v-if="reCourse.length == 0"></no-data>
                </div>
            </div>
        </div>
        <study-evaluate ref="evaluate" @evaluate_success="evaluateSuccess"></study-evaluate>
    </div>
</template>

<script>
import { numberDivide,openVirtual } from '@/utils/utils';
import { QuerySoftwareDetail, QuerySoftwareStatistics,CheckSoftware } from '@/api/software';
import detectProtocol from "custom-protocol-detection";
import { StartDrill } from '@/api/virtualSoftware';
import { QueryRecommendSoftware } from '@/api/recommend';
import { AddOptRecord } from '@/api/operation';
import { getFileInfo } from '@/api/common/commonFile';
import { OPERATIONTYPE } from '@/utils/utils';
import StudyEvaluate from '@/components/course/courseDetail/StudyEvaluate.vue';
import Evaluate from '@/components/course/courseDetail/Evaluate.vue';
import NoData from '@/components/common/NoData.vue';
import common from "@/assets/js/common";
import {
    checkTrainingLauncher,
    downloadTrainingLauncher,
    isThirdPartyStandaloneSoftware,
    openTrainingLauncher,
} from '@/utils/trainingLauncher';
export default {
    components: { StudyEvaluate, Evaluate, NoData },
    data() {
        return {
            OPERATIONTYPE,
            /**当前展示标题 */
            currentShowTitle: 'xfjs',
            /**评论数量 */
            evaluateNumber: 0,
            softwareId:'',
            activeName: 'target',
            detail: {},
            activeRead: 'hardware',
            statisticsData: {},
            /**推荐课程 */
            reCourse: [],
            good: require('../../../assets/image/operation/good.png'),
            noGood: require('../../../assets/image/operation/no-good.png'),
            collect: require('../../../assets/image/operation/sc.png'),
            noCollect: require('../../../assets/image/operation/no-sc.png'),
        }
    },
    methods: {
        numberDivide,
        /**启动第三方单机实训软件 */
        async startThirdPartyTrain() {
            const launcherInstalled = await checkTrainingLauncher();
            if (!launcherInstalled) {
                this.$confirm("未检测到可用的实训启动器，是否立即安装或更新？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    downloadTrainingLauncher();
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消下载"
                    });
                });
                return;
            }

            let packageFile = {
                fileUrl: this.detail.downloadUrl,
                md5: this.detail.packageMd5,
                fileName: this.detail.packageFileName,
            };
            if ((!packageFile.fileUrl || !packageFile.md5) && this.detail.fileId) {
                const fileRes = await getFileInfo(this.detail.fileId);
                if (fileRes.code === 200 && fileRes.data) packageFile = fileRes.data;
            }
            if (!packageFile.fileUrl || !packageFile.md5) {
                this.$msg({
                    showClose: true,
                    message: "软件安装包信息不完整",
                    type: "warning",
                });
                return;
            }

            const packageUrl = this.$severUrl(packageFile.fileUrl);
            const checkPOList = [{
                fullPath: packageUrl,
                softwareName: this.detail.softwareName
            }];
            const drillRes = await StartDrill({ id: this.softwareId, checkPOList });
            if (drillRes.code !== 200) return;
            this.querySoftwareStatistics();
            openTrainingLauncher({
                softwareId: this.detail.id || this.softwareId,
                trainingId: `sp_drill:${this.softwareId}`,
                softwareName: this.detail.softwareName,
                softwareCode: this.detail.softwareCode,
                packageUrl,
                packageMd5: packageFile.md5,
                packageFileName: packageFile.fileName,
                regedit: this.detail.regedit,
                version: packageFile.md5,
            });
        },
        /**仿真资源校验 */
        checkSoftware(){
            return new Promise(resolve=>{
                var url = openVirtual(this.detail.url) + '?optSource=sp_drill&businessId=' + this.softwareId;
                let params=[
                {
                    "fullPath": url,
                    "softwareName": this.detail.softwareName
                }
                ];
                CheckSoftware(params).then(res=>{
                    if(res.code==200){
                        resolve();
                    }
                });
            })
        },
        /**获取评论数量 */
        getTotal(e) {
            this.evaluateNumber = e || 0;
        },
        /**切换标题 */
        changeTitle(type) {
            this.currentShowTitle = type;
        },
        /**去掉字符串首尾特殊字符和空格 */
        trimSpecialChars(str, char) {
            if (!str) {
                return '';
            }
            str = str.trim();
            // 使用正则表达式去除首尾特定字符
            const regex = new RegExp(`(^${char}+)|(${char}+$)`, 'g');
            return str.replace(regex, '');
        },
        /**开始实训 */
        startTrain() {
            let token = common.getCookie("token");
            if (!token) {
                this.$store.commit('changeGoLogin', 'login');
                return;
            }
            if (isThirdPartyStandaloneSoftware(this.detail)) {
                this.startThirdPartyTrain().catch(() => {});
                return;
            }
            if (this.detail.resType == '网页') {
                let url='';
                if(this.detail.third===null){
                    url = openVirtual(this.detail.url) + '?optSource=sp_drill&businessId=' + this.softwareId;
                }else{
                    url=this.detail.url;
                }
                    let params=[
                    {
                        "fullPath": url,
                        "softwareName": this.detail.softwareName
                    }
                    ];
                    StartDrill({ id: this.softwareId,checkPOList:params}).then(res => {
                    if (res.code == 200) {
                        // var url = openVirtual(this.detail.url) + '?optSource=sp_drill&businessId=' + this.softwareId;
                        window.open(url, '_blank');
                    }
                });
            } else {
                if (!this.detail.regedit) {
                    this.$msg({
                        showClose: true,
                        message: "暂无资源",
                        type: "warning",
                    });
                    return;
                }
                detectProtocol(this.detail.regedit + '://', () => {
                    console.log("未找到协议.");
                    this.$confirm("未检测到软件，立即下载。", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                        .then(() => {
                            if (this.detail.fileId) {
                                getFileInfo(this.detail.fileId).then(res => {
                                    if (res.code == 200) {
                                        var src = this.$severUrl(res.data.fileUrl);
                                        var link = document.createElement('a');
                                        link.href = src;
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                    }
                                })
                            } else {
                                this.$msg({
                                    showClose: true,
                                    message: "暂无资源",
                                    type: "warning",
                                });
                            }
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消下载"
                            });
                        });
                },
                    () => {
                        console.log("找到自定义协议并成功打开文件.");
                    },
                    1000
                );
            }
        },
        /**推荐软件进入详情 */
        toDetail(item) {
            this.softwareId=item.id;
            this.$nextTick(() => {
                this.detail.softwareCover = '';
                this.evaluateSuccess();
                var params = {
                    "businessId": this.softwareId,
                    "businessType": 'software',
                    "optType": OPERATIONTYPE[2]
                }
                AddOptRecord(params);
                this.querySoftwareStatistics();
                let dom=document.querySelector('.mi-box');
                dom&&dom.scrollTo(0, 0);
            })
        },
        /**获取仿真软件统计数据 */
        querySoftwareStatistics() {
            QuerySoftwareStatistics({ id: this.softwareId }).then(res => {
                if (res.code == 200) {
                    this.statisticsData = res.data;
                }
            })
        },
        /**打开弹窗 */
        openDialog() {
            var dialog = this.$refs.evaluate;
            if (dialog) {
                dialog.id = this.softwareId;
                dialog.businessType = 'software';
                dialog.getQuestionnairesEvaluateList(()=>{
                    dialog.dialogVisible = true;
                });
            }
        },
        /**获取推荐仿真软件 */
        queryRecommendSoftware() {
            var params = {
                "id": this.softwareId,
                "classifyCode": this.detail.classify
            }
            QueryRecommendSoftware(params).then(res => {
                if (res.code == 200) {
                    this.reCourse = res.data;
                }
            })
        },
        evaluateSuccess() {
            this.querySoftwareDetail();
            var ev = this.$refs.ev;
            if (ev) {
                ev.list = [];
                ev.courseEvaluateList();
            }
        },
        /**获取详情 */
        querySoftwareDetail() {
            QuerySoftwareDetail({ id: this.softwareId }).then(res => {
                if (res.code == 200) {
                    this.detail = res.data;
                    this.queryRecommendSoftware();
                }
            })
        },
        /**新增操作记录 */
        addOptRecord(optType) {
            var params = {
                "businessId": this.softwareId,
                "businessType": 'software',
                "optType": optType
            }
            AddOptRecord(params).then(res => {
                if (res.code == 200) {
                    if(optType=== OPERATIONTYPE[0]){
                        this.detail.likes=!this.detail.likes;
                    }else{
                        this.detail.collect=!this.detail.collect;
                    }
                }
            });
        },
        getInitDetail(){
            this.querySoftwareDetail();
            var params = {
                "businessId": this.softwareId,
                "businessType": 'software',
                "optType": OPERATIONTYPE[2]
            }
            AddOptRecord(params);
            this.querySoftwareStatistics();
        }
    },
}
</script>

<style lang="less" scoped>
.top-box-content {
    background-color: #ffffff;
    padding: 3rem;
}
.mi-box{
    height: 100%;
    overflow: auto;
}
.page-title {
    color: #0D0825;
    font-size: 3rem;
    font-weight: 700;
    width: 40rem;
}
.detail-show-title{
    display: flex;
    margin-top: 3rem;
    justify-content: space-between;
}
.rate-box {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999999;
    font-size: 14px;

    &> :nth-child(1) {
        margin-top: 0.6rem;
    }

    &> :nth-child(2) {
        margin-left: 0.5rem;
    }

    i {
        cursor: pointer;
        font-size: 14px;
        margin-left: 1rem;
    }
}

.detail-p {
    white-space: var(--lineWrap);
    word-break: break-all;
    color: #334681;
    margin-top: 3rem;
}

.img-box {
    display: flex;
    justify-content: center;
    position: relative;

    .img-detail {
        // height: 36rem;
        width: 70rem;
        object-fit: cover;
    }
}

.bottom-mi-box {
    display: flex;
    margin-top: 2rem;

    .left-box {
        width: 74rem;
        padding: 3rem;
        background-color: #ffffff;

        .info-title {
            color: #151C34;
            font-size: 2rem;
            cursor: pointer;
        }

        .info-content {
            color: #334681;
            font-size: 14px;
            margin-top: 2.4rem;
            white-space: var(--lineWrap);
            min-height: 20rem;
        }
    }

    .right-box {
        flex: 1;
        margin-left: 2rem;
    }
}

.title {
    color: #151C34;
    font-size: 2rem;
}

.js-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 2rem;

    &> :nth-child(1) {
        color: #8590B3;
    }

    &> :nth-child(2) {
        color: #151C34;
    }
}

.btn-box {
    margin: 2.5rem 0;
    display: flex;
    align-items: center;
    color: #8590B3;

    &> :nth-child(2) {
        display: flex;
        align-items: center;
        margin-left: 2rem;

        i {
            margin-right: 0.5rem;
            cursor: pointer;
        }
    }

    &> :nth-child(3) {
        display: flex;
        align-items: center;
        margin-left: 2rem;

        i {
            margin-right: 0.5rem;
            cursor: pointer;
        }
    }
}

.second-box {
    padding: 3rem;
    background-color: #ffffff;

    #chart-box {
        height: 13rem;
        margin: 2rem 0;
    }
}

.three-box {
    padding: 3rem;
    background-color: #ffffff;
    margin-top: 2rem;
    min-height: 35rem;
}

.re-item {
    display: flex;
    margin-top: 2rem;
    color: #334681;
    cursor: pointer;

    .item {
        font-size: 16px;
        margin-left: 2rem;

        &> :nth-child(2) {
            font-size: 14px;
            color: #8590B3;
            margin-top: 0.5rem;
        }

        &> :nth-child(3) {
            color: #FFE769;
            font-weight: 700;
            margin-top: 1rem;
        }
    }

    img {
        width: 14rem;
        aspect-ratio: var(--aspectRatio);
    }
}

.content-ev-box {
    min-height: 15rem;

    &> :nth-child(n) {
        margin-top: 2.5rem;
    }

    &> :nth-child(1) {
        margin-top: 0;
    }
}

.dz {
    color: #FF4E00;
}

.sc {
    color: rgb(247, 186, 42);
}

.active-title {
    color: var(--blue) !important;
}
</style>
